// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"84f6e446","113":"e11d563e"}[chunkId] + ".chunk.js";
};